<template>
  <div class="box-item">

    <!--    评级-->
    <rankInfo v-if="dataObj.zmaFinancingManagement" :data="dataObj.zmaFinancingManagement" :cic-financing-apply-draft-snapshot="dataObj.cicFinancingApplyDraftSnapshot" />
    <z-collapse v-if="pagingParm.total" :title="$t('loan.riskAuditRecord')">
      <el-table :data="recordList.slice((pagingParm.pageNo-1)*pageSize, pagingParm.pageNo*pageSize)" :class="pagingParm.total>5? '':'pb-20'" class="dtl-tb">
        <el-table-column :label="$t('loan.auditConclusion')" prop="auditOpinion" width="700"/>
        <el-table-column :label="$t('loan.auditName')" prop="auditName" width="140"/>
        <el-table-column :label="$t('loan.date')" width="180">
          <template slot-scope="scope">{{ scope.row.createTime | dateTimeConvert }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="pagingParm.total>5"
        :total="pagingParm.total"
        :page-size="pagingParm.pageSize"
        :current-page.sync="pagingParm.pageNo"
        class="page-theme text-center pb_25"
        background
        layout="prev, pager, next"/>
    </z-collapse>
    <!--    风控审核记录  @current-change="sizeChange"-->
    <!--    商品走势-->
  </div>
</template>

<script>
import ZCollapse from '../ZCollapse'
import commodityChart from '@/components/KLineCommondity/index.vue' // 商品走势组件
import rankInfo from '@/components/financingComponents/rankInfo'
export default {
  name: 'BaseInfoTwo',
  components: {
    ZCollapse,
    commodityChart,
    rankInfo
  },
  props: {
    subBaseData: { // baseData
      type: Object
    }
  },

  data() {
    return {
      pageSize: 5,
      dataObj: this.subBaseData,
      rate: {},
      recordList: [], // 贸易审核记录 数据
      pagingParm: {
        pageNo: 1,
        total: 0
      },
      showChart: '', // 是否显示商品走势列表
      isCpSwitch: false, // 商品走势开关
      isFirst: true // 是否是第一次进入，第一次进入的时候不显示商品走势列表
    }
  },
  mounted() {
    console.log('this.dataObj==============', this.dataObj)
    this.rate = this.dataObj.zmaFinancingManagement
    this.recordList = this.dataObj.riskLog
    this.pagingParm.total = this.dataObj.riskLog.length
    this.showChart = !!this.rate.wareCode
    if (this.showChart) {
      this.getqlSwitch()
    }
  },
  methods: {
    /**
       * pageSize 分页事件
       * @param curPage 当前页
       */
    // sizeChange(curPage) {
    //   this.pagingParm.pageNo = curPage;
    //   let {pageNo, pageSize} = this.pagingParm;
    //   let {account, applicationStatus, financingStatus} = this.searchQuery;
    //   this.afterLoanList(account, this.statusHandle(applicationStatus), this.endTime, this.statusHandle(financingStatus), pageSize, pageNo, this.startTime);
    // },
    viewProdTrade() {
      // console.log('viewProdTrade');
      // //查看商品走势
      // this.$refs.commondityChartDialog.show(this.rate.wareCode);

      this.isFirst = false
      this.showChart = true
      this.initCommodity()
    },
    toggleCommidity() {
      this.$nextTick(() => {
        this.$refs.commodityChart.resetList()
      })
      this.showChart = false
    },

    initCommodity() {
      if (this.isCpSwitch && this.showChart && this.rate.wareCode && !this.isFirst) {
        const param = {
          wareCode: this.rate.wareCode
        }
        this.$nextTick(() => {
          this.$refs.commodityChart.handleInit(param)
        })
      }
    },

    getqlSwitch() {
      const _this = this
      _this.axios.post('/zmacommon/getqlSwitch', {}).then((res) => {
        if (res.status) {
          _this.isCpSwitch = res.data === 1
          _this.initCommodity()
        }
      })
    } // 获取商品走势列表展示开关
  }
}
</script>

<style lang="scss" scoped>
  .pr-trade{
    li{
      line-height: 24px;
    }
    .btn-blue{
      min-width: 100px;
      min-height: 24px;
      display: inline-block;
      text-align: center;
      line-height: 24px;
      box-sizing: border-box;
      padding: 0 20px;
      border-radius: 13px;
    }
  }
</style>
